import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { SELECTED_SIGNAL } from '../../../../../signals';
import { defaultContext, getFocusedStyle, getInitialStyle, getUnFocusedStyle } from './epgPopupEntry.style';

export class EpgPopupEntry extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Title: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._selected = false;
    this._focused = false;
  }

  _detach() {
    this._date = undefined;
  }

  get date() {
    return this._date;
  }

  set date(value) {
    this._date = value;
  }

  set title(value) {
    this.tag('Title').text.text = value;
  }

  get selected() {
    return this._selected;
  }

  set selected(value) {
    this._selected = value;
    this._updateStyle();
  }

  _focus() {
    this._focused = true;
    this._updateStyle();
  }

  _unfocus() {
    this._focused = false;
    this._updateStyle();
  }

  _updateStyle() {
    if (this._focused) {
      this.patch(getFocusedStyle(this._style, this._selected));
    } else {
      this.patch(getUnFocusedStyle(this._style, this._selected));
    }
  }

  _handleEnter() {
    this.signal(SELECTED_SIGNAL, this.date);

    return true;
  }
}
